/* eslint-disable-next-line padded-blocks */
import { useState } from "react";
import { Link } from "react-router-dom";
import { ptBR } from "date-fns/locale";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import html2pdf from "html2pdf.js";
import ReactDOMServer from "react-dom/server";
import * as XLSX from "xlsx";
//primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Panel from "../../../components/panel/panel";
import Select from "../../../components/input/Select";
import CalendarInput from "../../../components/input/CalendarInput";
import ModelReport from "../../../components/report/ModelReport";
//hooks
import { useOptionsSelect } from "../../../hooks/useOptionsSelect";
//services
import { getIndex } from "../../../services/GlobalRoles/getIndex";
import { postReportContractReadjust } from "../../../services/Report/postReportContractReadjust";
//utils
import { formatDate } from "../../../utils/formatDate";
import { TableContractstoReadjust } from "./TableContractstoReadjust";
import usePermission from "../../../hooks/usePermission";
import { useAppContext } from "../../../context/AppContext";

export default function ContractsToReadjust() {
  usePermission("130");
  const { permissions } = useAppContext();
  const [now, setNow] = useState();
  const [user, setUser] = useState();
  const [logo, setLogo] = useState();
  const [filters, setFilters] = useState([]);
  const [table, setTable] = useState([]);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const defaultValues = {
    status: "all",
  };
  const form = useForm({ defaultValues });
  const errors = form.formState.errors;

  // Watch dos campos de período para validação
  const periodStart = form.watch("period_start");
  const periodEnd = form.watch("period_end");

  const { enterprise, isLoadingEnterprises } = useOptionsSelect();

  const items = [
    {
      template: () => (
        <Link to={"/reports/contractsToReadjust"} className="p-breadcrumb-link">
          Contratos à reajustar
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const optionsMonths = [
    { value: 1, label: "Janeiro" },
    { value: 2, label: "Fevereiro" },
    { value: 3, label: "Março" },
    { value: 4, label: "Abril" },
    { value: 5, label: "Maio" },
    { value: 6, label: "Junho" },
    { value: 7, label: "Julho" },
    { value: 8, label: "Agosto" },
    { value: 9, label: "Setembro" },
    { value: 10, label: "Outubro" },
    { value: 11, label: "Novembro" },
    { value: 12, label: "Dezembro" },
  ];

  const optionsStatus = [
    { label: "Todos", value: "all" },
    { label: "Pendente", value: 0 },
    { label: "A Reajustar", value: 1 },
  ];

  // Opções filtradas para period_end baseadas no period_start
  const getFilteredEndMonths = () => {
    if (!periodStart) return optionsMonths;
    return optionsMonths.filter(month => month.value >= periodStart);
  };

  // Opções filtradas para period_start baseadas no period_end
  const getFilteredStartMonths = () => {
    if (!periodEnd) return optionsMonths;
    return optionsMonths.filter(month => month.value <= periodEnd);
  };

  // Função para resetar period_end se period_start for maior
  const handlePeriodStartChange = (value) => {
    if (periodEnd && value > periodEnd) {
      form.setValue("period_end", null);
      toast.warning("Mês de fim foi limpo pois deve ser maior ou igual ao mês de início!");
    }
  };

  // Função para resetar period_start se period_end for menor
  const handlePeriodEndChange = (value) => {
    if (periodStart && value < periodStart) {
      form.setValue("period_start", null);
      toast.warning("Mês de início foi limpo pois deve ser menor ou igual ao mês de fim!");
    }
  };

  const { data: index, isLoading: loadingIndex } = useQuery({
    queryKey: ["index"],
    queryFn: () => getIndex(),
    enabled: !!permissions?.includes("149"),
  });

  function formatStringDate(dateString) {
    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const onSubmit = async (data) => {
    setLoading(true);
    let period = "";
    let status = "";
    let indexReadjust = "";
    // data.period_start = formatStringDate(data.period_start);
    // data.period_end = formatStringDate(data.period_end);
    const notification = toast.loading(
      "Por favor aguarde a consulta está sendo realizada..."
    );
    indexReadjust = index.find((item) => item.id === data.index_id)?.name;
    // period = `de ${formatDate(data.period_start)} até ${formatDate(
    //   data.period_end
    // )}`;
    status = optionsStatus.find((item) => item.value === data.status)?.label;
    const today = new Date();
    const formattedDate = format(today, "dd 'de' MMMM 'de' yyyy", {
      locale: ptBR,
    });
    setNow(formattedDate);
    try {
      const response = await postReportContractReadjust(data);
      setTable(response);
      setUser(response.user.name);
      setLogo(response.enterprise.img && response.enterprise.img);
      const newFilters = [
        { title: "Empreendimento", content: response.enterprise.name },
        { title: "Índice", content: indexReadjust },
        { title: "Período", content: period },
        // { title: "Situação", content: status },
      ];
      setFilters(newFilters);
      toast.update(notification, {
        render: "Consulta Realizada!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoading(false);
      setVisible(true);
    } catch (e) {
      toast.update(notification, {
        render: "Houve um erro a buscar os dados, tente novamente",
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
      setLoading(false);
    }
    setVisible(true);
  };

  const handlePrint = () => {
    const headerContent = (
      <div style={{ color: "#000000" }}>
        <div>
          <div className="header-contract-land pt-3 pb-2">
            <div className="row">
              <div className="col-xl-3 col-md-4 d-flex justify-content-center">
                {logo && <img src={logo} alt="logo" width={100} />}
              </div>
              <div className="col-md-6 text-center pt-4">
                <h3 className="fw-bolder">
                  RELATÓRIO DE CONTRATOS À REAJUSTAR
                </h3>
              </div>
              <div className="col-xl-3 col-md-4 d-flex justify-content-end pt-4">
                <div className="mx-3 text-center">
                  <h6>{now}</h6>
                  <p style={{ fontSize: "9px" }}>Emitido por: {user}</p>
                </div>
              </div>
            </div>
            <div className="row text-center d-flex justify-content-center my-2">
              {filters.map((item, index) => (
                <div className="w-auto my-2 text-start d-flex" key={index}>
                  <h6 className="mx-3">
                    <span
                      className="fw-bolder text-gray"
                      style={{ fontSize: "13px" }}
                    >
                      {item.title}:{" "}
                    </span>{" "}
                    {item.content ? item.content.toString() : "N/A"}
                  </h6>
                  {index !== filters.length - 1 && (
                    <span className="mx-1" style={{ translate: "0px -2px" }}>
                      {" "}
                      |{" "}
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="table-content">
          <div className="my-1 text-center overflow-hidden">
            <TableContractstoReadjust table={table && table} />
          </div>
        </div>
      </div>
    );
    const htmlString = ReactDOMServer.renderToString(headerContent);

    const options = {
      margin: 30,
      filename: "relatorio_contratos_reajustar.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "pt", format: "letter", orientation: "portrait" },
    };

    const addPageNumbers = (pdf) => {
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.setTextColor(100);
        pdf.text(
          `Página ${i} de ${totalPages}`,
          pdf.internal.pageSize.getWidth() - 100,
          pdf.internal.pageSize.getHeight() - 15
        );
      }
    };

    const generatePDF = () => {
      // const pdf = new jsPDF(options.jsPDF);
      html2pdf()
        .from(htmlString)
        .set(options)
        .toPdf()
        .get("pdf")
        .then(function (pdfDoc) {
          addPageNumbers(pdfDoc);
          pdfDoc.save(options.filename);
        });
    };

    generatePDF();
  };

  const handleExportPDF = () => {
    const element = document.getElementById("contracts-report");
    if (!element) return;

    const options = {
      margin: 10,
      filename: "contratos-a-reajustar.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
    };

    html2pdf()
      .from(element)
      .set(options)
      .save()
      .then(() => {
        element.classList.remove("force-light");
      })
      .catch(() => {
        element.classList.remove("force-light");
      });
  };
  const handleExportExcel = () => {
    if (!table || typeof table !== "object") return;

    let rows = [];
    if (table.data && typeof table.data === "object") {
      Object.values(table.data).forEach((mes) => {
        if (Array.isArray(mes.data)) {
          rows.push(...mes.data);
        }
      });
    }
    if (rows.length === 0) {
      toast.warning("Nenhum dado para exportar!");
      return;
    }
    const headerMap = {
      id: "ID",
      enterprise: "Empreendimento",
      client: "Cliente",
      created_at: "Data Criação",
      block: "Quadra",
      land: "Lote",
      date_reajust: "Data Reajuste",
      index_reajusted: "Índice Reajuste",
    };

    const translatedRows = rows.map((row) => ({
      [headerMap.id]: row.id || "",
      [headerMap.enterprise]:
        typeof row.enterprise === "object"
          ? row.enterprise?.name || ""
          : row.enterprise || "",
      [headerMap.client]:
        typeof row.client === "object"
          ? row.client?.name || ""
          : row.client || "",
      [headerMap.created_at]: row.created_at || "",
      [headerMap.block]: row.block || "",
      [headerMap.land]: row.land || "",
      [headerMap.date_reajust]: row.date_reajust || "",
      [headerMap.index_reajusted]:
        typeof row.index_reajusted === "object"
          ? row.index_reajusted?.name || ""
          : row.index_reajusted || "",
    }));

    const filteredRows = translatedRows.filter((row) =>
      Object.values(row).some((val) => val !== "")
    );

    const ws = XLSX.utils.json_to_sheet(filteredRows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Contratos");
    XLSX.writeFile(wb, "contratos-a-reajustar.xlsx");
  };

  return (
    <div className="row d-flex justify-content-between mb-3">
      <div>
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      <Panel title="Relatório de Contratos à Reajustar">
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="row d-flex mt-4">
            <div className="col-xl-3 col-md-6 mb-3 form-group">
              <Select
                control={form.control}
                label={
                  isLoadingEnterprises ? "Carregando..." : "Empreendimento*"
                }
                name="enterprise_id"
                isRequired={true}
                disabled={isLoadingEnterprises}
                options={enterprise}
                errors={errors}
              />
            </div>
            <div className="col-xl-2 col-md-6 mb-3 form-group">
              <Select
                name="index_id"
                label={loadingIndex ? "Carregando..." : "Índice Reajuste"}
                errors={errors}
                control={form.control}
                options={
                  index &&
                  index.map((dado) => ({
                    value: dado.id,
                    label: dado.name,
                  }))
                }
              />
            </div>
            <div className="col-xl-3 col-md-6 mb-3 form-group">
              {/* <CalendarInput
                name="period_start"
                label="Data Início*"
                isRequired={true}
                errors={errors}
                control={form.control}
              // {...(form.getValues("status") === 1
              //   ? { minDate: new Date() }
              //   : {})}
              /> */}
              <Select
                name="period_start"
                control={form.control}
                label="Mês referência início"
                isRequired={true}
                options={getFilteredStartMonths()}
                errors={errors}
                onChange={(value) => handlePeriodStartChange(value)}
              />
            </div>
            <div className="col-xl-3 col-md-6 mb-3 form-group">
              {/* <CalendarInput
                name="period_end"
                label="Data Fim*"
                isRequired={true}
                errors={errors}
                control={form.control}
              // {...(form.watch("status") === 1 ? { minDate: new Date() } : {})}
              /> */}
              <Select
                name="period_end"
                control={form.control}
                label="Mês referência fim"
                isRequired={true}
                options={getFilteredEndMonths()}
                errors={errors}
                onChange={(value) => handlePeriodEndChange(value)}
              />
            </div>
            {/* <div className="col-xl-3 col-md-4 mb-3 form-group">
              <Select
                name="status"
                label="Situação"
                errors={errors}
                control={form.control}
                options={optionsStatus}
              />
            </div> */}
            <div className="col-xl-1 d-flex justify-content-end my-1 mt-2 pt-2">
              <div className={`w-100 text-center`}>
                <Button
                  type="submit"
                  icon="fa fa-search"
                  aria-label="Search"
                  loading={loading}
                  className={`rounded-3 py-2.5 w-100`}
                />
              </div>
            </div>
          </div>
        </form>
      </Panel>

      {loading && (
        <Skeleton width="100%" height="600px" className="mt-4"></Skeleton>
      )}

      {visible && !loading && (
        <Panel mainCss="mt-4">
          <>
            {/* <hr className="my-4" /> */}
            <div className="px-2 pb-3">
              <div className="d-flex gap-2 mb-3 justify-content-end">
                <Button
                  icon="fa fa-file-pdf"
                  className="p-button-secondary cursor-pointer"
                  rounded
                  onClick={handleExportPDF}
                />
                <Button
                  icon="fa fa-file-excel"
                  className="p-button-success cursor-pointer"
                  rounded
                  onClick={handleExportExcel}
                />
              </div>
              <div id="contracts-report">
                <ModelReport
                  date={now}
                  madeBy={user}
                  logo={logo}
                  // legend={
                  //   <>
                  //     <p className="mb-0">Legenda:</p>
                  //     <div>
                  //       <div className="d-flex justify-content-center">
                  //         <div
                  //           style={{
                  //             width: "20px",
                  //             height: "20px",
                  //             backgroundColor: "#F2E932",
                  //             borderRadius: "20px",
                  //           }}
                  //         ></div>
                  //         <h6 className="mt-1" style={{ marginLeft: "12px" }}>
                  //           Pendentes
                  //         </h6>
                  //       </div>
                  //       <div className="d-flex justify-content-center">
                  //         <div
                  //           style={{
                  //             width: "20px",
                  //             height: "20px",
                  //             border: "1px solid black",
                  //             borderRadius: "20px",
                  //           }}
                  //         ></div>
                  //         <h6 className="mt-1" style={{ marginLeft: "6px" }}>
                  //           À Reajustar
                  //         </h6>
                  //       </div>
                  //     </div>
                  //   </>
                  // }
                  title="RELATÓRIO DE CONTRATOS À REAJUSTAR"
                  filters={filters}
                >
                  <div className="text-center overflow-hidden">
                    <TableContractstoReadjust table={table} />
                  </div>
                </ModelReport>
              </div>
            </div>
          </>
        </Panel>
      )}
    </div>
  );
}
